/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Shop/CreditCard': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M24.995 23H7.005C6.45 23 6 22.55 6 21.995V14h20v7.995C26 22.55 25.55 23 24.995 23M7.005 9h17.99C25.55 9 26 9.45 26 10.005V11H6v-.995C6 9.45 6.45 9 7.005 9m17.998-2H6.997A2.997 2.997 0 004 9.997v12.006A2.997 2.997 0 006.997 25h18.006A2.997 2.997 0 0028 22.003V9.997A2.997 2.997 0 0025.003 7M13.75 19h-5.5a.248.248 0 00-.25.249v.502c0 .138.111.249.25.249h5.5a.25.25 0 00.25-.249v-.502a.25.25 0 00-.25-.249m10 0h-1.5c-.14 0-.25.11-.25.25v1.5c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25v-1.5c0-.14-.11-.25-.25-.25"/>'
  }
})
